import { useEffect, useState } from "react";
import getReservations from "../../../../../utils/getReservations";
import '../Dashboard/dashbooard.style.css';

function Dashboard() {
    const [reservations, setReservations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState('');

    useEffect(() => {
        const reservationsFetch = async () => {
            const reservationsData = await getReservations();
            if (reservationsData.status === 'OK') {
                const { data, user } = reservationsData;
                setUser(user);
                setReservations(data);
                setLoading(!loading)
            }
        }
        reservationsFetch();
    }, []);

    var num = 0;

    return (
        <section className="Dashboard-Section">
            <header className="Header-Admin">
                <nav>
                    <a>
                        B & M
                    </a>
                    <ul>
                        <li>
                            <div className="Icon-Number-Reservations">
                                <span> {reservations.length} </span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-plus" viewBox="0 0 16 16">
                                    <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
                                    <path fill-rule="evenodd" d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z" />
                                </svg>
                            </div>
                        </li>
                        <li> {user} </li>
                    </ul>
                </nav>
            </header>
            {
                loading ? <section>
                    <span>Cargando reservaciones</span>
                </section> : <section className="Container-Reservations">
                    <div className="Container-Reservations__Items">
                        {
                            reservations.map((reservation) => {
                                //console.log(reservation);
                                num =+1;
                                return <div key={num} className="Reservation-Item">
                                    <h2>{reservation.typeEvent}</h2>
                                    <div className="Reservation-Item_Information">
                                        <span><span>Nombre Cliente:</span><span> {reservation.name} </span></span>
                                        <span><span>cel:</span><span> {reservation.cel} </span></span>
                                        <span><span>Necesita Licor:</span><span> {reservation.licor} </span></span>
                                        <span><span>Cantidad de Horas:</span><span> {reservation.cantHours} </span></span>
                                        <span><span>Cantidad de Personas:</span><span> {reservation.cantPersons} </span></span>
                                    </div>
                                </div>
                            })
                        }
                    </div>
                </section>
            }
        </section>
    )
}

export default Dashboard;